import { store } from '../../../store';
import { BOOK_TYPE } from '../../book_define/book_type';
import BookItem from "../common/bookItem";
import { mouseEvent } from "../common/mouse_event";
import Visibility from "../common/visibility";
export default class JumpPage extends BookItem {
    /**
     *
     * @type {Visibility}
     * @memberof JumpPage
     */
    visibilityComponent = null;
    constructor(el, target) {
        super(el, target);
        this.el = el;
        this.isUsed = false;
        this.openAns = false;
        this.connectNumber = this.el.connectNumber;
        this.ctrlBookNumber = this.el.ctrlBookNumber;
        this.ctrlPageNumber = this.el.ctrlPageNumber;

        console.log("this.ctrlPageNumber", this.ctrlPageNumber);

        
    }

    //跳頁(等框架)

    init() {
        super.init();
        mouseEvent.add_mouse_event(this);
        this.target.gotoAndStop(0);
        this.target.visible = false;
        this.visibilityComponent = new Visibility(this.target, this, this.itemControl);
    }
    start() {
        this.visibilityComponent.setVisibleByGroup();
    }
    trigger() {
        // console.log('跳頁囉');
        //let page = parseInt(this.ctrlPageNumber) - 1;
        switch (store.nowBook) {
            case BOOK_TYPE.BOOK:
                store.currentBookPage = store.nowPage
                break;
            case BOOK_TYPE.STUDY:
                store.currentStudyPage = store.nowPage
                break;
        }
        window.pageControl.gotoPageByName(this.ctrlPageNumber, this.ctrlBookNumber)
    }
}